import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";
import {
  AcceptReferralReferralStatusEnum,
  PatientControllerApi,
} from "../../../services";

interface Props {
  patientId: string;
  referralUuid: string;
  referralStatus: AcceptReferralReferralStatusEnum;
  xTENANTID: string;
}
export const useAcceptReferralPatient = () =>
  useMutationWithLoading(
    async ({ patientId, referralUuid, referralStatus, xTENANTID }: Props) =>
      new PatientControllerApi(getConfigObject()).acceptReferral(
        patientId,
        referralUuid,
        referralStatus,
        xTENANTID
      )
  );
